<template>
  <div class="user_page">
    <h3 class="title-page">{{ $t("contracts") }}</h3>
    <div>
      <div class="admin_container">
        <div class="division_main">
          <div class="d-flex justify-start align-center mb-3">
            <!--            <ConfirmKeyDialog ref="confirmKeyDialogRef"></ConfirmKeyDialog>-->
            <!--            <template #filter.state>-->
            <!--              <div class="pa-1">-->
            <!--                <VueSelect-->
            <!--                    @input="onChangeHandler"-->
            <!--                    clearable-->
            <!--                    v-model="contractListFilter.status"-->
            <!--                    :items="contractItemStatusList"-->
            <!--                ></VueSelect>-->
            <!--              </div>-->
            <!--            </template>-->
            <!--            <template #filter.code>-->
            <!--              <div class="pa-1">-->
            <!--                <CustomInputText-->
            <!--                    clearable-->
            <!--                    v-model="contractListFilter.code"-->
            <!--                    @input="onChangeHandler"-->
            <!--                    class="user_input no-margin"-->
            <!--                    type="text"-->
            <!--                ></CustomInputText>-->
            <!--              </div>-->
            <!--            </template>-->
            <!--            <template #filter.itemNumb>-->
            <!--              <div class="pa-1">-->
            <!--                <CustomInputText-->
            <!--                    only="number"-->
            <!--                    clearable-->
            <!--                    v-model="contractListFilter.requestNumber"-->
            <!--                    @input="onChangeHandler"-->
            <!--                    class="user_input no-margin"-->
            <!--                    type="text"-->
            <!--                ></CustomInputText>-->
            <!--              </div>-->
            <!--            </template>-->
            <!--            <template #filter.productName>-->
            <!--              <div class="pa-1">-->
            <!--                <CustomInputText-->
            <!--                    clearable-->
            <!--                    v-model="contractListFilter.productName"-->
            <!--                    @input="onChangeHandler"-->
            <!--                    type="search"-->
            <!--                    class="for_icon_after search_input user_input no-margin search_input_contract"-->
            <!--                />-->
            <!--              </div>-->
            <!--            </template>-->
            <!--            <template #filter.conclusionDate>-->
            <!--              <div class="pa-1 d-flex align-center">-->
            <!--                  <span class="custom_input_label pt-1 pr-2">{{-->
            <!--                      $t("from")-->
            <!--                    }}</span>-->
            <!--                <CustomDatePicker-->
            <!--                    :max="contractListFilter.toDate || new Date()"-->
            <!--                    @input="onChangeHandler"-->
            <!--                    clearable-->
            <!--                    v-model="contractListFilter.fromDate"-->
            <!--                    label=""-->
            <!--                    name="calendar"-->
            <!--                    class="user_input mr-2 data_item data_item_calendar"-->
            <!--                    icon="mdi-calendar-month small"-->
            <!--                ></CustomDatePicker>-->
            <!--                <span class="custom_input_label pt-1">{{ $t("to") }}</span>-->
            <!--                <CustomDatePicker-->
            <!--                    :start-day="false"-->
            <!--                    @input="onChangeHandler"-->
            <!--                    clearable-->
            <!--                    :min="contractListFilter.fromDate"-->
            <!--                    :max="new Date()"-->
            <!--                    v-model="contractListFilter.toDate"-->
            <!--                    name="calendar_t"-->
            <!--                    color="#E3EBF3"-->
            <!--                    class="user_input data_input_tw ml-2 data_item"-->
            <!--                    icon="mdi-calendar-month small"-->
            <!--                ></CustomDatePicker>-->
            <!--              </div>-->
            <!--            </template>-->
            <!--            <template #filter.productTypeName>-->
            <!--              <div class="pa-1">-->
            <!--                <VueSelect-->
            <!--                    @input="onChangeHandler"-->
            <!--                    clearable-->
            <!--                    v-model="contractListFilter.typeId"-->
            <!--                    :items="productTypes"-->
            <!--                    infinite-->
            <!--                    :get-item-promise="-->
            <!--                      ({ page, text }) =>-->
            <!--                        $store.dispatch('getProductTypes', {-->
            <!--                          name: text,-->
            <!--                          page,-->
            <!--                          limit: 15,-->
            <!--                        })-->
            <!--                    "-->
            <!--                    @next-page-resolved="-->
            <!--                      (data) => setProductType([...productTypes, ...data])-->
            <!--                    "-->
            <!--                    @item-resolved="setProductType"-->
            <!--                ></VueSelect>-->
            <!--              </div>-->
            <!--            </template>-->
            <!--            <template #filter.supplierName>-->
            <!--              <div class="pa-1">-->
            <!--                <VueSelect-->
            <!--                    infinite-->
            <!--                    :get-item-promise="-->
            <!--                      ({ text, page }) =>-->
            <!--                        $store.dispatch('getSuppliers', {-->
            <!--                          limit: 15,-->
            <!--                          name: text,-->
            <!--                          page,-->
            <!--                        })-->
            <!--                    "-->
            <!--                    @next-page-resolved="-->
            <!--                      (data) => setSupplier([...suppliers, ...data])-->
            <!--                    "-->
            <!--                    @item-resolved="setSupplier"-->
            <!--                    clearable-->
            <!--                    v-model="contractListFilter.supplierId"-->
            <!--                    @input="onChangeHandler"-->
            <!--                    :items="suppliers"-->
            <!--                    class="search_input user_input"-->
            <!--                ></VueSelect>-->
            <!--              </div>-->
            <!--            </template>-->
            <!--            <template #filter.supplyType>-->
            <!--              <div class="pa-1">-->
            <!--                <VueSelect-->
            <!--                    clearable-->
            <!--                    v-model="contractListFilter.supplierType"-->
            <!--                    @input="onChangeHandler"-->
            <!--                    item-value="value"-->
            <!--                    :items="deliveryTypes"-->
            <!--                    type="search"-->
            <!--                    class="search_input"-->
            <!--                />-->
            <!--              </div>-->
            <!--            </template>-->
            <CustomSelect
              dense
              solo
              custom-selection
              custom-item
              :value="visibleHeaders"
              multiple
              @input="setHeader"
              item-text="text"
              item-value="value"
              :items="headers"
              class="user_input no-margin mt-1"
            >
              <template #item="{ attrs, item }">
                <div
                  class="column-setting-title-wrap flex-grow-1"
                  @click="changeColumnSettings(item, attrs)"
                >
                  <BaseCheckbox
                    class="mr-2"
                    v-model="visibleHeaders"
                    :value="item.value"
                  />
                  <span class="v-list-item__title" style="width: 100%">{{
                    item.text
                  }}</span>
                </div>
              </template>
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ $t("columns") }}</span>
              </template>
            </CustomSelect>
          </div>
          <div id="custom__table" class="mobile_simple overflow-auto">
            <TableWithFilter
              @change-header-order="onChangeHeaderOrder"
              @table-header-resized="onChangeSizeHeader"
              is-enabled-orderable-table
              isEnabledResizeTable
              :child-key="contractChildKey"
              :headers="filterableHeadersTable"
              :items="items"
              :options="tableOptions"
              fixed-header
              handlerValue="code"
              @update:sort="getContractsBySort"
            >
              <template #expandBtn="{ openHandler, item }">
                <TriangleBtn
                  :active="item.show"
                  :loading="item.loading"
                  @click="openHandler(item)"
                />
              </template>

              <!-- parent -->
              <template #item.conclusionDate="{ item }">{{
                item.conclusionDate | dateParse
              }}</template>
              <template #item.state="{ item }">
                <span
                  :style="{ color: item.statusColour }"
                  class="font-weight-bold"
                  >{{ $t("partiallyAccepted") }}</span
                >
              </template>
              <template #item.guessReceiveDate="{ item }">
                {{ item["guessReceiveDate"] | dateParse }}
              </template>
              <template #item.supplyType="{ item }">
                <span v-if="item.supplyType">{{
                  item.supplyType ? item.supplyType[`name_${$i18n.locale}`] : ""
                }}</span>
              </template>
              <template #item.supplierName="{ item }">
                <span>{{ item.supplier?.name }}</span>
              </template>
              <template #child.rejectReasen="{ child }">
                <span>{{ child.rejectReason }}</span>
              </template>
              <!-- child -->
              <template #child.action="{ child }">
                <VBtn @click="openViewDialog(child)" class="new_style">
                  <VueIcon icon="newEyeIcon"></VueIcon>
                </VBtn>
              </template>
              <template #child.itemNumb="{ child }">{{
                child.orderNumb
              }}</template>
              <template #child.numb="{ child }">{{ child.numb }}</template>
              <template #child.state="{ child }">
                <span
                  class="font-weight-bold"
                  :style="{
                    color:
                      child.state === contractItemStatus.CONTRACT_ITEM_ACCEPTED
                        ? '#36C281'
                        : child.state ===
                          contractItemStatus.CONTRACT_ITEM_REJECT
                        ? '#ee6565'
                        : '#FDCC05',
                  }"
                >
                  {{
                    child.state !== contractItemStatus.NEW
                      ? $t(`contractOmtkStatus.${child.state}`)
                      : ""
                  }}</span
                >
              </template>
              <template #child.guessReceiveDate="{ child }">
                {{ child["itemGuessReceiveDate"] | dateParse }}
              </template>
              <template #child.unitType="{ child }">{{
                child ? child[`unit_type_name_${$i18n.locale}`] : ""
              }}</template>
              <template #child.count="{ child }">{{
                child.count | numberParse
              }}</template>
              <template #child.productAttrs="{ child }">
                {{ child.productAttrs && child.productAttrs.join(" || ") }}
              </template>
              <template #child.productTypeName="{ child }">{{
                child.productCategory
                  ? child.productCategory[`name_${$i18n.locale}`]
                  : ""
              }}</template>
            </TableWithFilter>
            <VuePagination
              go-to
              @update:limit="
                (limit) => {
                  configuration.limit = limit;
                  configuration.page = 1;
                  changePage();
                }
              "
              v-model="configuration.page"
              :length="lastPage"
              @input="changePage"
              :limit="configuration.limit"
            />
          </div>
        </div>
      </div>
    </div>
    <ContractItemDialog
      ref="contractItemDialog"
      @updateTableData="updateTableData"
    ></ContractItemDialog>
  </div>
</template>

<script>
import TriangleBtn from "@/components/table-with-children/triangleBtn";
import TableWithFilter from "@/components/ui/table/TableWithFilter.vue";
import gridTableMixin from "@/configuration/mixins/gridTableMixin";
import {
  dateFormat,
  TABLES,
  deliveryTypes,
  contractItemStatus,
} from "@/utils/constants.js";
import {
  debounce,
  getQueryByKey,
  makerPagination,
  trueSet,
} from "@/utils/pureFunctions.js";
import VuePagination from "@/components/ui/vue-pagination/VuePagination.vue";
// import VueSelect from "@/components/ui/vue-select/VueSelect";
import BaseCheckbox from "@/components/ui/BaseCheckbox";
import ContractItemDialog from "@/components/omtk/ContractItemDialog.vue";
// import ConfirmKeyDialog from "@/components/ConfirmKeyDialog.vue";

import moment from "moment";

const FilterOmtkContracts = {
  code: null,
  fromDate: null,
  groupId: null,
  inisator: null,
  productName: null,
  status: null,
  supplierId: null,
  supplierType: null,
  toDate: null,
  typeId: null,
};
export default {
  name: "omtk-contracts",
  components: {
    VuePagination,
    TableWithFilter,
    TriangleBtn,
    // VueSelect,
    BaseCheckbox,
    ContractItemDialog,
    // ConfirmKeyDialog,
  },
  data() {
    return {
      lastPage: 0,
      items: [],
      productTypes: [],
      suppliers: [],
      contractListFilter: {
        ...FilterOmtkContracts,
      },
      tableOptions: {
        sortBy: "conclusionDate",
        sortDirection: true,
      },
      contractChildKey: "items",
      configuration: {
        total: 0,
        limit: 10,
        page: 1,
      },
    };
  },
  methods: {
    updateTableData() {
      this.getContracts();
      this.$refs.confirmKeyDialogRef.refreshList();
    },
    setProductType(productTypes) {
      this.productTypes = productTypes;
    },
    setSupplier(suppliers) {
      this.suppliers = suppliers;
    },
    setHeader(headers) {
      this.visibleHeaders = headers;
    },
    openViewDialog(child) {
      const { contractItemDialog } = this.$refs;

      contractItemDialog.open({
        ...child,
        unit_type_name: child
          ? child[`unit_type_name_${this.$i18n.locale}`]
          : "",
      });
    },
    async getContracts() {
      this.showLoading();
      try {
        const { page, limit } = this.configuration;
        let params = {
          page: page - 1,
          limit,
          // ...this.tableOptions,
          // ...this.contractListFilter,
          forOzl: false,
        };
        const {
          data: { data, total },
        } = await this.$http.get("/contract/office/list", { params });
        this.items = data.map((item) => {
          item.show = true;
          return item;
        });
        this.lastPage = makerPagination({ total: total, limit }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async getContractsBySort() {
      const { query: initialQuery } = this.$route;
      await this.$router.replace({
        query: { ...initialQuery, ...this.tableOptions },
      });
      this.showLoading();
      await this.getContracts();
      this.clearLoading();
    },
    async changePage(page) {
      const { query: initialQuery } = this.$route;
      const { page: queryPage } = initialQuery;
      if (page.toString() !== queryPage) {
        this.showLoading();
        await this.$router.replace({
          query: { ...initialQuery, page: page.toString() },
        });
        await this.getContracts();
        this.clearLoading();
      }
    },

    onChangeHandler: debounce(function () {
      let filter = { ...this.contractListFilter };
      if (filter.fromDate)
        filter.fromDate = moment(filter.fromDate).format(dateFormat);
      if (filter.toDate)
        filter.toDate = moment(filter.toDate).format(dateFormat);
      this.getContractsByFilter();
    }, 500),
    async getContractsByFilter() {
      this.showLoading();
      this.configuration.page = 1;
      await this.getContracts();
      await this.$router
        .replace({
          query: { ...this.tableOptions, ...this.contractListFilter },
        })
        .catch((err) => {
          console.warn(err);
        });
      this.clearLoading();
    },
  },
  mixins: [gridTableMixin(TABLES.Contract.slug)],
  computed: {
    deliveryTypes() {
      return [...deliveryTypes].map((item) => {
        return { ...item, name: this.$t(item?.name) };
      });
    },
    deliveryTypesIndex() {
      return deliveryTypes.reduce((init, item) => {
        init[item["value"]] = item;
        return init;
      }, {});
    },
    contractItemStatus: () => contractItemStatus,
    contractItemStatusList() {
      return Object.keys(contractItemStatus)
        .filter((item) => {
          return item !== contractItemStatus.NEW;
        })
        .map((item) => {
          return {
            name: this.$t(`contractOmtkStatus.${item}`),
            id: item,
          };
        });
    },
    filterableHeadersTable() {
      return this.headers.filter((item) => {
        return this.visibleHeaders.includes(item.value);
      });
    },
  },
  async created() {
    const { query } = this.$route;
    const tableOptions = getQueryByKey(this.tableOptions, query);
    if (query.page) this.configuration.page = +query.page;
    if (tableOptions.sortDirection)
      tableOptions.sortDirection = trueSet(tableOptions.sortDirection);
    this.tableOptions = tableOptions;
    this.contractListFilter = getQueryByKey(FilterOmtkContracts, query);
    this.showLoading();
    await Promise.all([this.getColumns(), this.getContracts()]);
    this.clearLoading();
  },
};
</script>

<style lang="scss">
.hooper-wrapper {
  .hooper {
    .hooper-list {
      ul {
        padding: 0 !important;
      }
    }
  }
}
#custom__table {
  .header_name_filter_table {
    background-color: #ffffff;
    border-bottom: 1px solid #dde6ef !important;
  }
  .header_filter_table {
    display: none;
  }
  .table_cover tbody tr td {
    border-bottom: 1px solid #dde6ef !important;
    border-top: 1px solid #dde6ef !important;
    border-right: 1px solid #dde6ef !important;
    border: none;
  }
}
</style>
